import React from 'react';

export default function About() {
    return (
        <main>
        <div className="page-description container">
        <h2 className="lead">
            Our motivation:
        </h2>
        <p>
            We know that building a computer is hard, we as college students personally suffered from trying to build a computer on our own in the past. We want our users to find the best setup to fufill their everyday needs as well
            as their performance hopes. 
            Our motivation is to help everyone have an easier and more cost efficient way to build a computer. Our features include submitting deals and filtering through those deals in 'Your Build' to keep track and
            eventually hit that 'Buy' button. We will be your companion throughout this process :)
        </p>
    </div> 
    </main>
    )
}